const init = e => {
  console.log('Running custom scripts...');

  if (!window.theme) window.theme || {}

  // Product Grid - Update swatch image on variant dropdown select
  theme.productGridSwatchChange = e => {
    const self = e.target;
    const selectedOption = self.options[self.selectedIndex];
    const id = selectedOption?.value;
    const image = selectedOption?.dataset.variantImage;
    if (!image || image == "null") return;

    const parent = self.closest('.grid-product');
    let el = parent.querySelector('.grid-product__color-image--' + id);
    if (!el || !self.options) return;

    parent.querySelectorAll('.grid-product__color-image').forEach(item => item.classList.remove('is-active'));
    el.style.backgroundImage = `url('${image}')`;
    el.classList.add('is-active');

    // Update hover image to display next option from selected
    const nextAvailableOption = index => {
      if (self.options[index] && self.options[index].disabled) {
        if (index === self.selectedIndex) {
          return self.options[self.selectedIndex];
        }
        else if (index === self.options.length) {
          return nextAvailableOption(0);
        }
        return nextAvailableOption(index + 1);
      }
      return self.options[index] ? self.options[index] : null;
    }
    const nextOptionImage = nextAvailableOption(self.selectedIndex + 1)?.dataset.variantImage;
    const hoverImgEl = parent.querySelector('.grid-product__secondary-image img');

    if (hoverImgEl && nextOptionImage) {
      hoverImgEl.src = nextOptionImage;
      hoverImgEl.removeAttribute('srcset');
      hoverImgEl.removeAttribute('data-srcset');
    }
  }

  const pgDropdowns = document.querySelectorAll('.js-grid-product__variants');
  pgDropdowns.forEach(dropdown => {
    dropdown.addEventListener('change', theme.productGridSwatchChange, false);

    // Initializes each dropdown to get correct swatch image on page load
    dropdown.dispatchEvent(new Event('change'));
  })

  document.addEventListener('recommendations:loaded', e => {
    const pgDropdowns = document.querySelectorAll('.js-grid-product__variants');
    pgDropdowns.forEach(dropdown => {
      dropdown.addEventListener('change', theme.productGridSwatchChange, false);

      // Initializes each dropdown to get correct swatch image on page load
      dropdown.dispatchEvent(new Event('change'));
    })
  });

  document.addEventListener('collections:loaded', e => {
    const pgDropdowns = document.querySelectorAll('.js-grid-product__variants');
    pgDropdowns.forEach(dropdown => {
      dropdown.addEventListener('change', theme.productGridSwatchChange, false);

      // Initializes each dropdown to get correct swatch image on page load
      dropdown.dispatchEvent(new Event('change'));
    })
  });


  // Product Grid - Add to cart
  theme.productGridAddToCart = async e => {
    const self = e.target;
    const parent = self.closest('.grid-product');
    const variantDropdown = parent.querySelector('select');
    const selectedVariant = variantDropdown?.options[variantDropdown.selectedIndex].value;
    let selectedPreOrderLimit = '';

    if (!selectedVariant || selectedVariant == '') return;

    if ( parent.querySelector('.propertiesPreOrderLimit') ) {
      selectedPreOrderLimit = parent.querySelector('.propertiesPreOrderLimit').value;
    }

    let selectedVariantInventorypolicy = variantDropdown?.options[variantDropdown.selectedIndex].getAttribute('data-inventorypolicy');

    let selectedVProductHandle = variantDropdown?.options[variantDropdown.selectedIndex].getAttribute('data-producthandle');

    let tags = (parent.dataset.tags).split(',');
    let items = [];
    let obj = {
      id: JSON.parse(selectedVariant),
      quantity: 1,
      properties: {
        // "PreOrderLimit": selectedPreOrderLimit
      }
    }

    if ( selectedVariantInventorypolicy == 'continue' && !selectedPreOrderLimit ) {
      selectedPreOrderLimit = await fetch(theme.routes.home + 'products/' + selectedVProductHandle +
      '?variant=' + selectedVariant +
      '&view=variant',
      {
          method: "GET"
      })
      .then(res => {
        return res.text();
      });

      obj = {
        id: JSON.parse(selectedVariant),
        quantity: 1,
        properties: {
          // "PreOrderLimit": preOrderLimit
        }
      }
    }

    let hasDiscountTag = tags.find(t => t.includes('_discount_'));
    if (hasDiscountTag) {
      obj.properties = {
        "_discount": true
      }
    }
    items.push(obj)

    const aw = await fetch(theme.routes.cart, {
      method: 'GET',
    })
    .then(response => response.json())
    .then(res => {
      let checker = res.items.find(x => x.variant_id == selectedVariant);

      if ( checker && selectedPreOrderLimit && checker.quantity >= selectedPreOrderLimit) {
        
        alert('Sorry, Pre Order Limit Reached!');

        self.classList.remove('btn--loading');

        return true;
      } else {
      }
    })

    if( aw ) return

    if (!selectedVariant) return;
    try {
      self.classList.add('btn--loading');

      const res = await fetch(theme.routes.cartAdd, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      });

      const data = await res.json();

      if(res.ok) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data,
            addToCartBtn: self
          }
        }));
      }
    }
    catch (err) {
      self.classList.remove('btn--loading');
    }
    finally {
      self.classList.remove('btn--loading');
    }
  }
  const pgAtcBtns = document.querySelectorAll('.js-product-grid-atc');
  pgAtcBtns.forEach(btn => {
    btn.addEventListener('click', theme.productGridAddToCart, false);
  })

  document.addEventListener('recommendations:loaded', e => {
    const pgAtcBtns = document.querySelectorAll('.js-product-grid-atc');
    pgAtcBtns.forEach(btn => {
      btn.addEventListener('click', theme.productGridAddToCart, false);
    })
  });

  document.addEventListener('collections:loaded', e => {
    const pgAtcBtns = document.querySelectorAll('.js-product-grid-atc');
    pgAtcBtns.forEach(btn => {
      btn.addEventListener('click', theme.productGridAddToCart, false);
    })
  });


  const convertToDecimal = amount => parseInt(+amount, 10) / 100;
  const cleanAmount = amount => parseFloat(amount.toFixed(2));


  // Product bundle page form
  const bundleForm = document.querySelector('.js-submit-bundle-form');
  if (bundleForm) {
    const bundleFormElements = Array.from(bundleForm.elements);
    const bundleFormSubmitBtn = bundleFormElements.find(el => el.tagName.toLowerCase() === 'button');
    const bundleVariants = bundleFormElements.filter(el => el.name === 'grid product bundle variant');

    console.log({bundleVariants});

    const validateBundleVariants = (e) => {
      let unselected = bundleVariants.filter((el) => el.value === null || el.value === 'undefined' || el.value === '');
      if (unselected.length === 0) {
        bundleFormSubmitBtn.textContent = "Add bundle to cart";
        bundleFormSubmitBtn.removeAttribute('disabled');
      }
    };

    const submitBundleForm = async e => {
      e.preventDefault();

      const self = e.target;
      const data = JSON.parse(self.nextElementSibling.innerText);
      if (!data) return;

      const {
        id,
        title,
        handle,
        tags,
        featured_image: img,
        price: bundlePrice,
        compare_at_price: bundleCompareAtPrice
      } = data;
      const totalVariantsSum = bundleVariants.reduce((acc, el) => {
        if (el.tagName === 'INPUT') {
          return acc + +el.dataset.price
        }
        return acc + +el.options[el.selectedIndex].dataset.price
      }, 0);
      const rate = bundleCompareAtPrice && bundleCompareAtPrice > bundlePrice ?
        bundlePrice / bundleCompareAtPrice :
        bundlePrice / totalVariantsSum;
      const randomGeneratedID = Math.floor((Math.random() * 1000000) + 1);
      const variants = bundleVariants.map((el) => el.value).join('|');
      let items = [], temp = 0;

      console.log({bundleVariants})
      for (const [i, el] of bundleVariants.entries()) {
        console.log({i, el})
        const index = i + 1;
        const price = convertToDecimal(el.tagName === 'INPUT' ? el.dataset.price : el.options[el.selectedIndex].dataset.price);
        let saving = cleanAmount(price * Math.abs(rate));

        if (index === bundleVariants.length) {
          const bundlePriceDecimal = convertToDecimal(bundlePrice);
          const difference = cleanAmount(bundlePriceDecimal - temp);
          saving = difference === saving ? saving : Math.abs(difference);
        }
        temp = cleanAmount(temp + saving);

        items.push({
          quantity: 1,
          id: el.value,
          properties: {
            "_bundle": `${handle}|${id}`,
            "_bundleUniqueID": randomGeneratedID,
            "_bundleName": title,
            "_bundleImage": img,
            "_bundlePrice": bundlePrice,
            "_bundleCompareAtPrice": bundleCompareAtPrice,
            "_saving": Math.abs(saving),
            "_bundleVariants": variants,
            "_bundleTags": tags.toString()
          }
        })
      }

      if (items.length === 0) return;

      try {
        bundleFormSubmitBtn.classList.add('btn--loading');

        let res = await fetch('/cart/add.js', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: items
            })
        });
        let data = await res.json();

        if (res.ok) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: data
            }
          }));
        }
      }
      catch (err) {
        console.log(err);
        bundleFormSubmitBtn.classList.remove('btn--loading');
      }
      finally {
        bundleFormSubmitBtn.classList.remove('btn--loading');
      }
    };

    bundleVariants.forEach(dropdown => {
      dropdown.addEventListener('change', validateBundleVariants, false);
    });
    bundleForm.addEventListener('submit', submitBundleForm, false);
  }


  // Remove line cart item via ajax
  const removeLineItemCart = async e => {
    const self = e.target;
    const key = self.dataset.key;

    if (!key) return;
    try {
      self.classList.add('btn--loading');

      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: 0
        })
      });
      const data = await res.json();

      if (res.ok) {
        document.dispatchEvent(new CustomEvent('cart:build', {
          detail: {
            cart: data
          }
        }));
      }
    }
    catch (err) {
      console.log(err);
      self.classList.remove('btn--loading');
    }
    finally {
      self.classList.remove('btn--loading');
    }
  }
  const removeLineItems = document.querySelectorAll('.js-remove-line-item');
  removeLineItems.forEach(btn => {
    btn.addEventListener('click', removeLineItemCart, false);
  });

  // Remove bundle from cart and cart drawer
  const removeBundleFromCart = async e => {
    const self = e.target;
    const variants = self.dataset.bundleKeys;
    const variantsArr = Array.from(variants.split(','));

    let obj = variantsArr.reduce((o, key) => ({ ...o, [key]: 0}), {});
    console.log(obj);

    try {
      self.classList.add('btn--loading');

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: obj
        })
      });
      const data = await res.json();

      if (res.ok) {
        document.dispatchEvent(new CustomEvent('cart:build', {
          detail: {
            cart: data
          }
        }));
      }
    }
    catch (err) {
      console.log(err);
      self.classList.remove('btn--loading');
    }
    finally {
      self.classList.remove('btn--loading');
    }
  }
  const removeBundleBtns = document.querySelectorAll('.js-remove-bundle');
  removeBundleBtns.forEach(btn => {
    btn.addEventListener('click', removeBundleFromCart, false);
  });


  // Show bundle product slider if cart item is part of the bundle
  const renderSlider = (elem, data) => {
    const container = document.createElement('div');
    const heading = document.createElement('h3');
    const trigger = document.createElement('button');
    const slider = document.createElement('div');
    const formatMoney = amt => {
      return `$${(amt / 100).toFixed(2)}`;
    }
    let flkty;
    let flktyOptions = {
      cellAlign: 'left',
      wrapAround: true,
      pageDots: false
    };

    heading.classList.add('bundle-heading');
    heading.innerHTML = `**This item is available in a bundle**`;

    slider.classList.add('bundle-slider', 'js-bundle-slider', 'hide');
    slider.innerHTML = [...data].map(product => {
      return `
        <div class="bundle-slider--item cart__item" data-key="${product.id}">
          <div class="cart__image">
            <a href="/products/${product.handle}">
              <img src="https:${product.featured_image}" alt="${product.title}">
            </a>
          </div>
          <div class="cart__item-details">
            <div class="cart__item-title">
              <a href="/products/${product.handle}" class="cart__item-name">${product.title}</a>
              <div class="cart__item-price-col">
                ${ product.compare_at_price_min > product.price_min ?
                  ` <span class="visually-hidden">Regular price</span>
                    <small class="cart__price cart__price--strikethrough">${formatMoney(product.compare_at_price_min)}</small>
                    <span class="visually-hidden">Sale price</span>
                    <span class="cart__price cart__discount">${formatMoney(product.price_min)}</span>
                  ` :
                  ` <span class="cart__price">${formatMoney(product.price_min)}</span>`
                }
              </div>
              <a href="/products/${product.handle}" class="text-link btn btn--secondary btn--small">View bundle</a>
            </div>
          </div>
        </div>
      `;
    }).join('');

    if (data.length < 1) {
      flkty = new Flickity(slider, flktyOptions);
    }

    trigger.classList.add('btn', 'btn--full', 'js-show-bundle-slider');
    trigger.textContent = 'Show matching bundles';
    trigger.setAttribute('type', 'button');
    trigger.addEventListener('click', e => {
      trigger.classList.add('hide')
      slider.classList.remove('hide');

      if (data.length < 1) flkty.resize();
    });

    container.appendChild(heading);
    container.appendChild(trigger);
    container.appendChild(slider);

    elem.appendChild(container);
  };

  const displayBundleSlider = async elem => {
    const collections = elem.dataset.collections?.split(',');;
    const bundleArr = collections.filter(title => title.indexOf('bundle') !== -1);
    const fetchArr = bundleArr.map(handle => fetch(`/products/${handle}.js`));

    try {
      const results = await Promise.all(fetchArr);
      const dataPromises = results.map(result => result.json());
      const finalData = await Promise.all(dataPromises);

      renderSlider(elem, finalData);
    }
    catch (err) {
      console.log(err);
    }
  }

  const bundleSliderTriggers = document.querySelectorAll('.js-cart-item-has-bundle');
  bundleSliderTriggers.forEach(displayBundleSlider);


  // Enable flickity slider on cart cross sell
  const enableSlider = (elem, args = { cellAlign: 'left', wrapAround: true, pageDots: true, prevNextButtons: false }) => {
    let flkty = new Flickity(elem, args);
    return flkty;
  }

  const crossSellSlider = document.querySelector('.cross-sell-products');
  if (crossSellSlider) enableSlider(crossSellSlider);
  document.addEventListener('drawerOpen', e => {
    const crossSellSlider = document.querySelector('.cross-sell-products');
    if (crossSellSlider) {
      let flkty = Flickity.data(crossSellSlider);
      flkty.resize();
    }
  });

  const flktyElems = document.querySelectorAll('.js-enable-flkty');
  flktyElems.forEach(elem => {
    const itemCount = JSON.parse(elem.dataset.itemCount);
    const args = { cellAlign: 'center', wrapAround: true, pageDots: true, prevNextButtons: false, imagesLoaded: true };
    let flkty = enableSlider(elem, args);

    const resizeObserver = new ResizeObserver(entries => {
      for(let entry of entries) {
        if (entry.contentBoxSize) {
          const {inlineSize} = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;
          if (inlineSize > 768) {
            if (itemCount <= 5) {
              flkty.destroy()
            }
            else {
              flkty = enableSlider(elem, args)
            }
          } else {
            if (itemCount < 2) {
              flkty.destroy()
            }
            else {
              flkty = enableSlider(elem, args)
            }
          }
        } else {
          if (entry.contentRect.width > 768) {
            if (itemCount <= 5) {
              flkty.destroy()
            }
            else {
              flkty = enableSlider(elem, args)
            }
          } else {
            if (itemCount < 2) {
              flkty.destroy()
            }
            else {
              flkty = enableSlider(elem, args)
            }
          }
        }
      }
    });

    resizeObserver.observe(elem);
  });

  // Reinit functions on cart build event
  document.addEventListener('cart:ready', e => {
    const removeLineItems = document.querySelectorAll('.js-remove-line-item');
    removeLineItems.forEach(btn => {
      btn.addEventListener('click', removeLineItemCart, false);
    });

    const removeBundleBtns = document.querySelectorAll('.js-remove-bundle');
    removeBundleBtns.forEach(btn => {
      btn.addEventListener('click', removeBundleFromCart, false);
    });

    const bundleSliderTriggers = document.querySelectorAll('.js-cart-item-has-bundle');
    bundleSliderTriggers.forEach(displayBundleSlider);

    const crossSellSlider = document.querySelector('.cross-sell-products');
    if (crossSellSlider) {
      let flkty = Flickity.data(crossSellSlider);
      flkty.resize();
    }
  });



  // Slider on feature collection sections
  const featuredCollectionSliders = document.querySelectorAll('.product-slider .grid');
  const initSlider = elem => {
    let flkty = new Flickity(elem, {
      cellAlign: 'left',
      wrapAround: true,
      pageDots: false
    });
  }
  featuredCollectionSliders.forEach(initSlider);


  // Read more
  const showDescriptions = e => {
    const self = e.target;
    const parent = self.parentElement;
    const dots = parent.querySelector('.dots');
    const more = parent.querySelector('.more');

    if (!parent || !dots || !more) return;

    self.classList.toggle('active');
    if (dots.classList.contains('hide')) {
      dots.classList.remove('hide');
      more.classList.add('hide');
      self.textContent = 'Read more';
    } else {
      dots.classList.add('hide');
      more.classList.remove('hide');
      self.textContent = 'Read less';
    }
  }
  const rmTriggers = document.querySelectorAll('.js-read-more');
  rmTriggers.forEach(trigger => {
      trigger.addEventListener('click', showDescriptions, false);
  });


  // Close instagram feed popup on outside click
  const instafeedSections = document.querySelectorAll('.instafeed-tabs');
  const instafeedListener = elem => {
    const observer = new MutationObserver((mutationList, observer) => {
      let contentLoaded = mutationList.find(mutation => mutation.type === 'childList');

      if (!contentLoaded) {
        observer.disconnect();
        return;
      }

      document.addEventListener('click', e => {
        const self = e.target;
        if (!self.closest('.lightbox-instagram')) {
          const closeBtn = self.querySelector('#close-button-url');
          if (closeBtn) closeBtn.click();
        }
      }, false);

      observer.disconnect();
    });
    observer.observe(elem, {
      attributes: false,
      childList: true,
      subtree: true
    });
  }
  instafeedSections.forEach(instafeedListener);

  document.addEventListener('change', function (event) {
    if (event.target.classList.contains('product-single__variants')) {
      let selected = event.target.options[event.target.selectedIndex];

      let preorderquantitylimit = selected.dataset.preorderquantitylimit;
      let customerquantitylimit = selected.dataset.customerquantitylimit;
      let maxquantitylimit = selected.dataset.maxquantitylimit;
      let inventorypolicy = selected.dataset.inventorypolicy;

      const addToCartButon = document.querySelector('.product-single__meta span[data-add-to-cart-text]');
      const productQuantityInput = document.querySelector('.product-single__meta .js-qty__num');

      const addToCartButtonEl = document.querySelector('.product-single__meta [data-add-to-cart]');
      const productQuantityInputEl = document.querySelector('.product-single__meta .js-qty__wrapper');

      const propertiesPreOrderLimit = document.querySelector('.product-single__meta #propertiesPreOrderLimit');

      let max_message = false;
      if (customerquantitylimit) {
        max_message = `(Max: ${customerquantitylimit > maxquantitylimit ? maxquantitylimit : customerquantitylimit})`
      }

      if ( addToCartButon && productQuantityInput && propertiesPreOrderLimit ) {
        if ( preorderquantitylimit > 0 && inventorypolicy == 'continue' ) {
          addToCartButon.innerHTML = `Pre Order${max_message ? ' ' + max_message : ''}`;
          productQuantityInput.setAttribute('max',maxquantitylimit);
          propertiesPreOrderLimit.value = maxquantitylimit;

          if (maxquantitylimit == 0) {
            addToCartButtonEl.disabled = true;
            addToCartButtonEl.classList.add('disabled');
            addToCartButon.innerHTML = 'Sold Out';
          } else {
            addToCartButtonEl.disabled = false;
            addToCartButtonEl.classList.remove('disabled');
            addToCartButon.innerHTML =  `Pre Order${max_message ? ' ' + max_message : ''}`;
          }
        } else {
          addToCartButon.innerHTML = 'Add to Cart';
          productQuantityInput.setAttribute('max','');
          propertiesPreOrderLimit.value = '';
        }
        // reset quantity to 1
        productQuantityInput.value = 1;
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', init, false);